// extracted by mini-css-extract-plugin
export default {"wrapper":"RevealChatComponent_wrapper__RmEsH"};